module.exports = __webpack_public_path__ + "static/media/auto-small-placeholder.afabc7d9.webp";